export default __webpack_public_path__ + "static/placeholder-f548f770c4648745be1c5472d2ec3bef.jpg";